import { Button, Typography } from "@mui/material";
import { useState } from "react";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { createListStore } from "../../common/listStore";
import { UseEntityStore } from "../../common/entityStore";
import { CustomerDto } from "./types";
import { map } from "rxjs";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { CustomerAddressDialog } from "./CustomerAddressDialog";
import { Add, Delete, Edit } from "@mui/icons-material";
import { createAxios } from "../../common/axios";
import { sortAddresses } from "./common";

export function CustomerAddressList(props: {
    useCustomerStore: UseEntityStore<CustomerDto>;
    disabled: boolean;
}) {
    const [useStore] = useState(() => createListStore({
        data: props.useCustomerStore.getState().serverData$.pipe(map(p => ({
            items: sortAddresses(p.data.customerAddresses).map(p => ({ ...p, strt: p.strt1 + " " + p.strt2 })),
            isFetching: p.isFetching,
        }))),
        itemsPerPage: 5,
        listProps: [
            { column: "position", label: "ID", width: 50 },
            { column: "fname", label: "First name", width: 110 },
            { column: "lname", label: "Last name", width: 130 },
            { column: "coadr", label: "C/O address", width: 130 },
            { column: "strt", label: "Address", width: 150, },
            { column: "city", label: "City", width: 150, },
            { column: "zipCode", label: "ZIP code", width: 80, },
        ],
    }));
    const newDialog = useDialog(close => <CustomerAddressDialog close={close} customerAddress={null}
        useCustomerStore={props.useCustomerStore} disabled={props.disabled} />, "md");
    const editDialog = useDialog(close => <CustomerAddressDialog close={close} customerAddress={selectedItem!}
        useCustomerStore={props.useCustomerStore} disabled={props.disabled} />, "md");
    const { selectedItem } = useStore(p => ({ selectedItem: p.selectedItem }));
    const simpleDialog = useSimpleDialog();
    async function deleteAddress() {
        await simpleDialog.show("Delete customer address", "Delete selected customer address?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`customers/customerAddresses/${selectedItem!.id}`);
            }
            finally {
                props.useCustomerStore.getState().fetchServerData();
            }
        }));
    }
    return <>
        {newDialog.render()}
        {editDialog.render()}
        {simpleDialog.render()}
        <Typography variant="h6">Delivery addresses</Typography>
        {renderListStore(useStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()} disabled={props.disabled}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={selectedItem == null || props.disabled} title="Delete" onClick={deleteAddress}><Delete /></Button>],
            ]),
            getRowClass: p => !p.isActive ? ["redRibbon"] : [],
        })}
    </>;
}
